/**
 * Scelta della lingua (Andrea 2026-10-09): Italiano / English. Salva prima
 * sul profilo (se loggati) e poi sul telefono; il cambio ricarica la pagina.
 */

import { impostaLingua, LINGUE, type Lingua, useLingua } from "../../i18n";
import { CHIAVE_SYNC_LINGUA } from "../../i18n/SincronizzaLingua";
import { api } from "../../lib/api";
import { type User, useAuthStore } from "../../lib/auth-store";
import { tr } from "../../i18n";

export function SelettoreLingua({ compatto = false }: { compatto?: boolean }) {
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const attuale = useLingua();

  const scegli = async (l: Lingua) => {
    if (attuale === l) return;
    // Prima il profilo: cosi' dopo la ricarica lo store e il telefono sono
    // d'accordo e SincronizzaLingua non rimette la lingua vecchia.
    if (user && user.lingua !== l) {
      try {
        const res = await api.patch<User>("/auth/me", { lingua: l });
        setUser(res.data);
      } catch {
        /* resta salvata sul telefono */
      }
    }
    try {
      sessionStorage.setItem(CHIAVE_SYNC_LINGUA, l);
    } catch {
      /* ignora */
    }
    impostaLingua(l);
  };

  return (
    <div
      role="radiogroup"
      aria-label={tr("Lingua")}
      className={`flex gap-1 p-1 rounded-xl bg-primary-deep/70 border border-primary/30 ${
        compatto ? "" : "w-full"
      }`}
    >
      {LINGUE.map((l) => (
        <button
          key={l.id}
          type="button"
          role="radio"
          aria-checked={attuale === l.id}
          onClick={() => void scegli(l.id)}
          className={`flex-1 rounded-lg font-bold transition whitespace-nowrap ${
            compatto ? "px-2 py-1 text-[11px]" : "px-2 py-2 text-xs"
          } ${attuale === l.id ? "bg-accent text-ink shadow" : "text-fg-muted hover:text-fg"}`}
        >
          <span aria-hidden className="mr-1">
            {l.bandiera}
          </span>
          {l.nome}
        </button>
      ))}
    </div>
  );
}
